import { SET_AFFILIATE_SOURCE_TYPE } from 'actions';

export function setAffiliateSourceType(sourceType: string) {
  return { sourceType, type: SET_AFFILIATE_SOURCE_TYPE };
}
